// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2000 ? "e99863e0" : chunkId) + "." + {"2000":"59e3a018414648a5","2725":"6a8a18f249eb6763","7678":"00796c2cda35b2d6"}[chunkId] + ".js";
};